/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodWareDishIcon16Solid = forwardRef('FoodWareDishIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.75 3.8a1.5 1.5 0 1 0-1.5 0v.995A6.252 6.252 0 0 0 1.77 10.5c-.022.275.204.5.48.5h11.5a.471.471 0 0 0 .48-.5 6.252 6.252 0 0 0-5.48-5.705v-.996Z" }),
        React.createElement("path", { d: "M1 12a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H1Z" })));
});
